module.exports = __webpack_public_path__ + "static/media/home-gallery-image5.e9025305.png";